import { Button, Container } from '@chakra-ui/react'
import { Content } from '@twlvxtwlv/ui/src/components/shared/content'
import { Page } from '@twlvxtwlv/ui/src/components/shared/page'
import { Section } from '@twlvxtwlv/ui/src/components/shared/section'
import { promises as fs } from 'fs'
import type { GetStaticProps, GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'
import path from 'path'

interface PrivacyPolicyPageProps {
  content: string
}

export default function PrivacyPolicyPage({
  content,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const { t } = useTranslation(['common'])

  function handlePrivacyPolyButtonClick() {
    // @ts-expect-error: Cannot find name
    UC_UI.showSecondLayer()
  }

  return (
    <Page bgColor="white">
      <Head>
        <title>{t('meta-title-legal-privacy-policy')}</title>
      </Head>
      <Section>
        <Container maxW="840px">
          <Content content={content} />
          <Button onClick={handlePrivacyPolyButtonClick}>
            {t('privacy-policy-cookie-button-title')}
          </Button>
        </Container>
      </Section>
    </Page>
  )
}

export const getStaticProps: GetStaticProps<PrivacyPolicyPageProps> = async ({
  locale = 'de',
}: GetStaticPropsContext) => {
  const filePath = path.join(process.cwd(), 'public/markdown/privacy_policy.md')
  const content = await fs.readFile(filePath, 'utf8')
  return {
    props: {
      content,
      ...(await serverSideTranslations(locale, ['common', 'navigation', 'footer'])),
    },
  }
}
